"use client";
import { Avatar, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { isMobile } from "react-device-detect";
import { signOut, useSession } from "next-auth/react";
import { UserSession } from "@/utils/types";
import Link from "next/link";
import { useDrawer } from "@/utils/DrawerProvider";
import { useTranslation } from "react-i18next";

export const MobileHeader = () => {
  const session = useSession().data as UserSession;
  const { openDrawer, closeDrawer } = useDrawer();
  const pathName = usePathname();

  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (isMobile !== undefined) {
      setMobile(isMobile);
    }
  }, [isMobile]);
  if (mobile && !pathName.includes("login") && !pathName.includes("signup"))
    return (
      <div
        className="space-between vcenter white-bg p5 pl10 pr20 mobile-only "
        style={{
          position: "fixed",
          top: "0px",
          zIndex: "1000",
          width: "100vw",
        }}
      >
        <IconButton
          size="small"
          className=""
          onClick={() =>
            openDrawer({ title: "", content: <MobileMenu />, anchor: "left" })
          }
        >
          <HiOutlineMenuAlt2 color="#16489f" />
        </IconButton>
        {session?.role && (
          <Link href={"/profile"}>
            <Avatar
              src={`/api/images/uploads/${session?.profile_pic}`}
              sx={{ width: 30, height: 30 }}
            />
          </Link>
        )}
      </div>
    );
};
import { useRouter, useSearchParams } from "next/navigation";
import { usePathname } from "next/navigation";
import i18nConfig from "@/app/i18nConfig";
import ReactFlagsSelect from "react-flags-select";
import { styled } from "@mui/system";
// import Image from "next/image";
const MobileMenu = ({ drawerid }: { drawerid?: string }) => {
  const session = useSession().data as UserSession;
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language as "ar" | "fr" | "en";

  const router = useRouter();
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const { openDrawer, closeDrawer } = useDrawer();

  const [lang, setLang] = useState(
    currentLocale == "fr" ? "FR" : currentLocale == "en" ? "US" : "DZ"
  );
  const handleChange = React.useCallback(
    (newLocale: string) => () => {
      console.log(newLocale, "newK");
      const days = 30;
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "; expires=" + date.toUTCString();
      document.cookie = `NEXT_LOCALE=${newLocale};expires=${expires};path=/`;
      const current = new URLSearchParams(Array.from(searchParams.entries()));
      const search = current.toString();
      if (currentLocale === i18nConfig.defaultLocale) {
        if (searchParams.size != 0)
          router.push("/" + newLocale + pathName + "?" + search);
        if (searchParams.size == 0) router.push("/" + newLocale + pathName);
      } else {
        if (searchParams.size != 0)
          router.push(
            pathName.replace(`/${currentLocale}`, `/${newLocale}`) +
              "?" +
              search
          );
        if (searchParams.size == 0)
          router.push(pathName.replace(`/${currentLocale}`, `/${newLocale}`));
      }

      router.refresh();
    },
    [currentLocale, pathName, router]
  );
  return (
    <>
      <div className="mobile-menu mobile-only">
        <div>
          <div className="  h100 ">
            <div className="grid gap20 p30">
              {session?.role && (
                <>
                  <div>
                    <Link
                      href={"/about"}
                      onClick={() => closeDrawer(drawerid ?? "")}
                    >
                      {" "}
                      {t("aboutUs")}{" "}
                    </Link>
                  </div>
                  <div>
                    <Link
                      href={"/faq"}
                      onClick={() => closeDrawer(drawerid ?? "")}
                    >
                      {" "}
                      {t("FAQ's")}{" "}
                    </Link>
                  </div>
                  <div
                    onClick={async () => {
                      //@ts-ignore
                      window.logout = function () {
                        console.log("logging");
                        const event_msg = JSON.stringify({
                          type: "logout",
                        });
                        //@ts-ignore

                        if (window["Flutter"])
                          //@ts-ignore

                          window["Flutter"].postMessage(event_msg);
                      };
                      await signOut();
                      router.push("/login");
                      return { success: true };
                    }}
                  >
                    {t("logout")}{" "}
                  </div>
                </>
              )}
              {!session?.role && (
                <>
                  <div>
                    <Link
                      href={"/login"}
                      onClick={() => closeDrawer(drawerid ?? "")}
                    >
                      {" "}
                      {t("login")}{" "}
                    </Link>
                  </div>
                  <div>
                    <Link
                      href={"/signup"}
                      onClick={() => closeDrawer(drawerid ?? "")}
                    >
                      {" "}
                      {t("signup")}{" "}
                    </Link>
                  </div>
                </>
              )}
              <div className="c1-auto vcenter gap20">
                <p> {t("language")} : </p>
                <ReactFlagsSelectStyled
                  selected={lang}
                  onSelect={(e) => {
                    // closeDrawer(drawerid?? "")
                    setLang(e);
                    let lang = e == "FR" ? "fr" : e == "US" ? "en" : "ar";
                    handleChange(lang)();
                  }}
                  countries={["FR", "US", "DZ"]}
                  showSelectedLabel={false}
                  showOptionLabel={false}
                  selectButtonClassName="menu-flags-button"
                  placeholder={" "}
                />
              </div>
            </div>
          </div>
        </div>
        <img src="/logo.png" alt="" className="h80px w100" />
      </div>
    </>
  );
};

export const ReactFlagsSelectStyled = styled(ReactFlagsSelect)`
  .ReactFlagsSelect-module_selectBtn__19wW7:after,
  .ReactFlagsSelect-module_selectBtn__19wW7[aria-expanded="true"]:after {
    display: none;
  }
  .ReactFlagsSelect-module_selectBtn__19wW7 {
    padding: 0px;
    border: 0px solid #eee;
  }
  .ReactFlagsSelect-module_selectOption__3pcgW {
    padding: 0px 8px;
  }
  .ReactFlagsSelect-module_selectOptions__3LNBJ {
    margin-top: 0px;
  }

  .ReactFlagsSelect-module_flagsSelect__2pfa2 {
    padding-bottom: 0px;
  }
`;
